import React, { Component } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { PATHS } from './properties';
import {
  okButton, setFingerPrint, setCoordenadas, setIP, setOptionSelectedMenu, cargaInfo, serviciosNoDisponibles, setSaldoTotal,
  setRendimientos, setTiposServicios, setPosicionCartera, recargaCartera, setSaldoLiquido, setSaldoOperacion,
  setTiposServiciosOpera, hideComposicion, hideComposicionLumina, hideOperacion, hideToken
} from './redux/actions';
import { setDataUser, setContratos, setCurrentContrato, setChequera } from './redux/actionsServices';
import { getDeviceToken, deleteSesion, toReload, getConfiguracionCR, getInfo, decryptValue, cerrarTodosLosModales } from './utils';
import { SERVICES, MINUTOS_SESION, MENUS } from './properties';
import { ICONS } from './assets/icons';
import M from 'materialize-css';
import Nav from './components/nav';
import firebase from 'firebase';
import jQuery from 'jquery';
import Graphs from './components/graphs';
// import SaldoLiquido from './components/saldoLiquido';
import DesbloqueCuenta from './components/desbloqueoCuenta';
import ResetPass from './components/resetPassword';

import FondosInversion from './components/fondosInversion';
import Notificaciones from './components/notificaciones';
import Faq from './components/faq';

import Login from './components/newLogin' //'./components/login';

import OK_BUTTON_MODAL from './components/okButton_modal';
import RemueveContrato from './components/remueveContrato';
import Token from './components/token';
import Operaciones from './components/operaciones';
import Composicion from './components/composicion';
import ComposicionLumina from './components/composicionLumina';

import SinAutorizacion from './components/sinAutorizacion';
import IdleTimer from 'react-idle-timer';

import loadFlr from './assets/loading.flr';

import _ from 'lodash';
import FlareComponent from 'flare-react';

import NotFound from './components/404';
import avisoPrivacidad from './components/avisoPrivacidad';
import terminosCondiciones from './components/terminosCondiciones';
import ModalInfo from './components/modalInfo';
import PopupLogin from './components/popupLogin';
import SesionInactiva from './components/SesionInactiva';
import ModalFchNac from './components/modalFchNac';
import InternetStatusManager from './components/InternetStatusManager';
import OrdenesPendientes from './components/ordenesPendientes';
import fondosInversionTemp from './components/fondosInversionTemp';
import FondosInver from './components/FondosInver';

class App extends Component {

  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.handleOnAction = this.handleOnAction.bind(this)
    this.handleOnActive = this.handleOnActive.bind(this)
    this.handleOnIdle = this.handleOnIdle.bind(this)
  }

  state = {
    user: false,
    contrato: false,
    permisosGeo: false,
    mostrarNav: true,
    loading: false,
    isTimedOut: false,
    tips_imagenes_temporada: false,
    tip_txt: false,
    publicRoutes: ['/preguntas_frecuentes', '/extravioRobo', '/olvidePass', '/actualizaPass', '/desbloqueo', '/faq']
  }



  async componentDidUpdate(prevProps, prevState) {


    if (!_.isEqual(prevProps.dataUser, this.props.dataUser)) {
      if (this.props.dataUser) {

        M.Sidenav.init(document.querySelectorAll('.sidenav'), {});
        M.Sidenav.init(document.querySelectorAll('.sidenavUser'), {
          edge: "right",
          onCloseEnd: () => {
            this.props.setOptionSelectedMenu(false);
          }
        });
      } else {
        this.limpiarModalesSinSesion();
        this.setState({ user: false, loading: false }, () => {

        });
      }
    }



    if (prevProps.esRecargaCartera !== this.props.esRecargaCartera) {
      if (this.props.esRecargaCartera) {
        this.props.recargaCartera(false);
        this.recarga();
        this.getTips();
      }
    }

  }


  //Al perder la sesión (por cualquier ruta) cierra los modales y limpia su estado.
  //Se conserva el aviso de fin de sesión (modal_okButton / modalInfo).
  limpiarModalesSinSesion() {
    cerrarTodosLosModales(['modal_okButton', 'modalInfo']);

    for (let hide of [this.props.hideComposicion, this.props.hideComposicionLumina, this.props.hideOperacion, this.props.hideToken]) {
      try {
        hide();
      } catch (error) {
      }
    }
  }

  recarga = async () => {
    try {
      await toReload({ dataUser: this.props.dataUser, props: this.props }, this.props.currentContrato);
    } catch (error) {
    }
  }

  componentDidMount = async () => {
    try {
      this.getTips();
      this.initMaterializeComponents();

      await this.getConfiguracionSecret();
      //this.props.cargaInfo(true);
      await this.getIp();
   


      //Va por la información del usuario.
      let dataUser = false;// localStorage.getItem('dataUser');

      var vuFp = new window.VUBrowserFP();

      vuFp.getFingerprintInfo((info) => {
        //Info a enviar al server en Base64  
        this.props.setFingerPrint(info.fingerprint);
        //this.props.setFingerPrint('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');
        window.fingerprint = info.fingerprint;
      });

      if (dataUser) {
        //Va por la configuracion inicial
        let dataParse = JSON.parse(dataUser);
        dataParse.IdUsuario = dataParse.IdUsuario.toLowerCase();

        try {
          dataParse.deviceToken = await getDeviceToken(dataParse.uid)

          await toReload({ dataUser: dataParse, props: this.props });

          this.setState({ loading: false }, () => {
            this.props.cargaInfo(false);
          });

        } catch (error) {
          this.props.serviciosNoDisponibles(true);
          this.props.cargaInfo(false);
          this.props.setDataUser(false);
        }

      } else {
        this.setState({ loading: false }, () => {
          this.props.cargaInfo(false);
        });
      }
    } catch (error) {

      this.setState({ loading: false });

    }

    M.Modal.init(document.querySelectorAll('.modalRecarga'), {
      dismissible: false,
      onOpenStart: () => {
        this.getTips();
      }
    });

    M.Sidenav.init(document.getElementById('sidenavNoSesion'), {});

  }

  decodeData = (base64Text) => {
    // Decodificar el texto Base64 a bytes
    const bytes = atob(base64Text);

    // Convertir los bytes a un arreglo de caracteres
    let utf8Text = '';
    for (let i = 0; i < bytes.length; i++) {
      utf8Text += String.fromCharCode(bytes.charCodeAt(i));
    }

    // Decodificar UTF-8
    const decodedText = decodeURIComponent(escape(utf8Text));

    return decodedText;
  }

  getConfiguracionSecret = async () => {


    try {
      const configs = await getConfiguracionCR();

      if (configs) {
        window.config = {
          "APP_RIV": this.decodeData(configs.iv),
          "APP_KCR_OBS": this.decodeData(configs.key),
        }
      }
    } catch (error) {

    }
  }

  getTips = () => {

    if (!this.state.tips_imagenes_temporada) {
      firebase.firestore().doc(MENUS.TIPS_IMAGENES_TEMPORADA).get().then((snapshot) => {
        if (snapshot.exists) {
          let tips = snapshot.data().tips_loader;
          this.setState({ tips_imagenes_temporada: tips, tip_txt: tips[Math.floor(Math.random() * tips.length)] });
        }
      });
    } else {
      this.setState({ tip_txt: this.state.tips_imagenes_temporada[Math.floor(Math.random() * this.state.tips_imagenes_temporada.length)] });
    }


  }



  getRandomTip = () => {
    if (this.state.tip_txt) {
      return (<div className='col s12'>
        <div className='row'>
          <div className='col s12 center-align titleTips'>
            Tips de Seguridad
          </div>
          <div className='col s12 center-align contentFaq tipTxt'>
            {decodeURIComponent(escape(atob(this.state.tip_txt)))}
          </div>
        </div>
      </div>)
    }
    return <div></div>;
  }


  getIp = async () => {
    try {
      let ip = await jQuery.get(SERVICES.GET_IP.url);
      this.props.setIP(ip.ip);

    } catch (error) {
      this.props.setIP(false);
      this.props.okButton({
        message: "No pudimos obtener todos sus datos de geolocalización, no podemos habilitar el acceso a Valmex Web.",
        title: "Advertencia", txtButton: "Entendido",
        statusCode: 404
      });

    }
  }

  getClassContainer({ dataUser, location }) {


    if (document.location && (document.location.pathname === '/' || document.location.pathname === '/inicio') && !dataUser) {
      return '';
    } else {
      return "valmexContainer";
    }
  }

  render() {
    let { dataUser, sDisponibles } = this.props;



    return (

      <div>
        <BrowserRouter>
          <SesionInactiva />

          {/* <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            timeout={60 * 1000 * MINUTOS_SESION}
            onActive={this.handleOnActive}
            onIdle={this.handleOnIdle}
            onAction={this.handleOnAction}
            debounce={250}
          /> */}
          <Nav user={dataUser} />
          <div className={this.getClassContainer({ dataUser, location: this.props.location })}>

            {
              sDisponibles ?

                <div className="row">
                  <div className="col s12 center-align mt-3">
                    <img src={ICONS.NO_SERVICES} alt="Servicios no disponibles" />
                  </div>
                  <div className="col s12 center-align">
                    {
                      sDisponibles && sDisponibles.message
                        ?
                        <p>{sDisponibles.message}</p>
                        :
                        <p>Servicio no disponible por el momento, por favor intente mas tarde.</p>

                    }

                    {
                      sDisponibles && sDisponibles.sessionExpired
                        ?
                        <button className="btn primaryBtn" onClick={() => {
                          this.props.serviciosNoDisponibles(false);
                          this.props.history.push(PATHS.LOGIN);
                        }}>
                          Iniciar Sesion
                        </button>
                        : null
                    }

                  </div>

                </div>
                :

                <Switch>
                  <Route path={PATHS.RESET_PASS} component={ResetPass} exact />
                  <Route path={PATHS.NOTIFICACIONES} component={dataUser ? Notificaciones : Login} exact />
                  <Route path={PATHS.PREGUNTAS_FRECUENTES} component={Faq} exact />
                  <Route path="/faq" exact>
                    <Redirect to={PATHS.PREGUNTAS_FRECUENTES} />
                  </Route>
                  <Route path={PATHS.FONDOS_INVERSION} component={dataUser ? FondosInver : Login} exact />
                  <Route path={PATHS.ROBO_EXTRAVIO} component={DesbloqueCuenta} exact />
                  <Route path={PATHS.DESBLOQUEO} component={DesbloqueCuenta} exact />
                  <Route path={PATHS.OLVIDE_PASS} component={DesbloqueCuenta} exact />
                  <Route path={'/inicio'} component={dataUser ? Graphs : Login} exact />
                  {/* <Route path={PATHS.SALDO_LIQUIDO} component={dataUser ? SaldoLiquido : Login} exact /> */}
                  <Route path={PATHS.SIN_AUTORIZACION} component={SinAutorizacion} exact />
                  <Route path={PATHS.LOGIN} component={dataUser ? Graphs : Login} exact />
                  <Route path={PATHS.AVISO_PRIVACIDAD} component={avisoPrivacidad} />
                  <Route path={PATHS.TERMINOS_CONDICIONES} component={terminosCondiciones} />
                  <Route component={NotFound} />
                </Switch>
            }


            <Token />

            <OK_BUTTON_MODAL />
            <RemueveContrato />
            <Operaciones />
            <Composicion />
            <ComposicionLumina />
            <OrdenesPendientes />
            <div id="modalRecarga" className="modal modalRecarga">
              <div className="modal-content" style={{ height: "100%" }}>
                <div className="valign-wrapper" style={{ height: "100%" }}>
                  <div className="row">
                    <div className="col s12 center-align">

                      <FlareComponent width={200} height={200} animationName="Loading" file={loadFlr} />
                    </div>
                    {
                      this.getRandomTip()
                    }
                  </div>
                </div>
              </div>
            </div>
          </div >
          <ModalInfo />
          <PopupLogin />
          <ModalFchNac />
          <InternetStatusManager />
        </BrowserRouter>
      </div>

    )
  }

  initMaterializeComponents() {
    M.updateTextFields();
    M.Modal.init(document.querySelectorAll('.modal_okButton'), {
      dismissible: false
    });

    M.Modal.init(document.querySelectorAll('.modal_token'), {
      dismissible: false
    });

    M.Modal.init(document.querySelectorAll('.remueveContratoModal'), {
      dismissible: false
    });

    M.Modal.init(document.querySelectorAll('.model_operacion'), {
      dismissible: false
    });

  }

  handleOnAction(event) {
    // console.log('user did something', event)
    this.setState({ isTimedOut: false });
  }

  handleOnActive(event) {
    //  console.log('user is active', event)
    //  console.log('time remaining', this.idleTimer.getRemainingTime())
    this.setState({ isTimedOut: false });
  }

  handleOnIdle(event) {

    const isTimedOut = this.state.isTimedOut;

    if (this.props.dataUser && isTimedOut) {

      deleteSesion(this.props.dataUser.IdUsuario, this.props);
      this.props.serviciosNoDisponibles({
        message: "Apreciable cliente su sesión ha expirado, lo invitamos a ingresar nuevamente.",
        sessionExpired: true
      })
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

}

const mapStateToProps = state => {
  let { dataUser, currentContrato, menuPrincipal, history, sDisponibles,
    esRecargaCartera, coordenadas } = false;
  if (state.servicesActions) {
    dataUser = state.servicesActions.dataUser || false;
    currentContrato = state.servicesActions.currentContrato || false
  }

  if (state.commonsActions) {
    coordenadas = state.commonsActions.coordenadas || false;
    menuPrincipal = state.commonsActions.menuPrincipal || false;
    history = state.commonsActions.history || false;
    sDisponibles = state.commonsActions.sDisponibles || false;
    esRecargaCartera = state.commonsActions.esRecargaCartera || false;
  }
  return {
    dataUser, currentContrato, menuPrincipal, history,
    sDisponibles, esRecargaCartera,
    coordenadas
  };
};


export default connect(mapStateToProps,
  {
    okButton,
    setFingerPrint,
    setDataUser,
    setContratos,
    setCurrentContrato,
    setChequera,
    setCoordenadas,
    setIP,
    setOptionSelectedMenu,
    cargaInfo,
    serviciosNoDisponibles,
    hideComposicion,
    hideComposicionLumina,
    hideOperacion,
    hideToken,
    setSaldoTotal,
    setRendimientos,
    setTiposServicios,
    setPosicionCartera,
    recargaCartera,
    setSaldoLiquido,
    setSaldoOperacion, 
    setTiposServiciosOpera
  })(App)
